"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var logger_1 = require("./logger");

var WebSocketChannel =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(WebSocketChannel, _events_1$EventEmitte);

  function WebSocketChannel(url) {
    var _this;

    _classCallCheck(this, WebSocketChannel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebSocketChannel).call(this));
    _this.url = url;
    _this.WebSocket = global['WebSocket'] || global['MozWebSocket'] || require('ws');
    return _this;
  }

  _createClass(WebSocketChannel, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;

      logger_1.log.trace('connecting to socket');
      var socket = new this.WebSocket(this.url);
      socket.binaryType = 'arraybuffer';

      socket.onopen = function () {
        logger_1.log.debug("socket opened ".concat(_this2.url));

        _this2.emit('connected');
      };

      socket.onclose = function (e) {
        logger_1.log.debug('socket closed', e);

        _this2.emit('disconnected', e);
      };

      socket.onerror = function (e) {
        logger_1.log.debug('error:', e);

        _this2.emit('socketError', e);
      };

      socket.onmessage = function (message) {
        _this2.emit('message', message.data);
      };

      this.socket = socket;
    }
  }, {
    key: "send",
    value: function send(message) {
      this.socket.send(message);
    }
  }, {
    key: "close",
    value: function close() {
      logger_1.log.trace('closing socket');

      if (this.socket) {
        this.socket.onopen = null;
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket.onmessage = null;

        try {
          this.socket.close();
        } finally {}
      }
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.socket && this.socket.readyState === 1;
    }
  }]);

  return WebSocketChannel;
}(events_1.EventEmitter);

exports.WebSocketChannel = WebSocketChannel;